import React, { useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Gift, CheckCircle2 } from 'lucide-react';
const bonos = [{
  id: 'B1',
  title: 'Cheatsheet ECG de Bolsillo',
  short: '20 tarjetas plastificables',
  desc: '20 tarjetas visuales imprimibles con los ritmos y criterios que más se usan en guardia. Plastificá y llevá.',
  image: 'https://images.unsplash.com/photo-1530497610245-94d3c16cda28?auto=format&fit=crop&w=600&q=80',
  accent: 'from-red-500 to-pink-600'
}, {
  id: 'B2',
  title: 'Calculadoras Clínicas Esenciales',
  short: 'CURB-65, Wells, Glasgow + más',
  desc: '20 tarjetas con las fórmulas más usadas en guardia: CURB-65, Wells, Glasgow, anión gap, QTc y más.',
  image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=600&q=80',
  accent: 'from-blue-500 to-cyan-600'
}, {
  id: 'B3',
  title: 'Guía de Drogas en Guardia',
  short: 'Dosis y contraindicaciones',
  desc: '20 tarjetas de referencia rápida con dosis, indicaciones y contraindicaciones de los fármacos esenciales en urgencias.',
  image: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?auto=format&fit=crop&w=600&q=80',
  accent: 'from-purple-500 to-fuchsia-600'
}, {
  id: 'B4',
  title: 'Casos Clínicos Extra',
  short: '20 casos para entrenar',
  desc: '20 casos clínicos adicionales con presentación, preguntas guía, diagnóstico y razonamiento. Para simular guardias antes de estar frente al paciente.',
  image: 'https://images.unsplash.com/photo-1582719188393-bb71ca45dbb9?auto=format&fit=crop&w=600&q=80',
  accent: 'from-amber-500 to-orange-600'
}, {
  id: 'B5',
  title: 'Checklist Pre-Guardia',
  short: 'Lista de verificación visual',
  desc: 'Lista de verificación visual para entrar a cada guardia preparado, organizado y con criterio clínico desde el primer minuto.',
  image: 'https://images.unsplash.com/photo-1590402494682-cd3fb53b1f70?auto=format&fit=crop&w=600&q=80',
  accent: 'from-green-500 to-emerald-600'
}, {
  id: 'B6',
  title: 'Acceso a Comunidad Privada',
  short: 'Grupo exclusivo de estudiantes',
  desc: 'Grupo exclusivo de estudiantes de medicina donde compartís dudas, casos y recursos con otros compradores del atlas.',
  image: 'https://images.unsplash.com/photo-1622253692010-333f2da6031d?auto=format&fit=crop&w=600&q=80',
  accent: 'from-teal-500 to-cyan-600'
}];
export function BonosSlider() {
  const [expandedId, setExpandedId] = useState<string | null>(null);
  const toggleExpand = (id: string) => {
    setExpandedId(expandedId === id ? null : id);
  };
  return <section className="py-16 px-4 bg-medical-blue overflow-hidden relative" data-id="element-16">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5" data-id="element-17">
        <div className="absolute top-10 left-10 w-64 h-64 rounded-full bg-white blur-3xl" data-id="element-18"></div>
        <div className="absolute bottom-10 right-10 w-64 h-64 rounded-full bg-accent-gold blur-3xl" data-id="element-19"></div>
      </div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-20">
        <div className="text-center mb-12" data-id="element-21">
          <div className="inline-flex items-center gap-2 bg-success-green text-white font-bold px-4 py-1.5 rounded-full text-xs mb-4 tracking-widest shadow-lg" data-id="element-22">
            <Gift size={14} data-id="element-23" />
            INCLUIDOS GRATIS
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-extrabold text-white mb-3" data-id="element-24">
            6 Bonos Clínicos
          </h2>
          <p className="text-lg text-blue-100 font-medium" data-id="element-25">
            Sin costo extra — incluidos en todas las ofertas
          </p>
        </div>

        {/* Vertical list of horizontal cards */}
        <div className="space-y-3" data-id="element-26">
          {bonos.map((bono, index) => {
          const isExpanded = expandedId === bono.id;
          return <motion.div key={bono.id} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.4,
            delay: index * 0.05
          }} className={`bg-white rounded-2xl shadow-lg overflow-hidden cursor-pointer transition-all ${isExpanded ? 'shadow-2xl ring-2 ring-accent-gold' : 'hover:shadow-xl'}`} onClick={() => toggleExpand(bono.id)} data-id="element-27">
                <div className="flex flex-row items-stretch" data-id="element-28">
                  {/* Image side */}
                  <div className="relative w-24 sm:w-36 md:w-44 shrink-0 overflow-hidden" data-id="element-29">
                    <img src={bono.image} alt={bono.title} className="w-full h-full object-cover" loading="lazy" data-id="element-30" />
                    <div className={`absolute inset-0 bg-gradient-to-br ${bono.accent} opacity-60 mix-blend-multiply`} data-id="element-31"></div>

                    {/* GRATIS ribbon */}
                    <div className="absolute top-0 left-0 bg-success-green text-white text-[10px] font-black px-2 py-1 rounded-br-lg shadow-md" data-id="element-32">
                      GRATIS
                    </div>

                    {/* B# badge */}
                    <div className="absolute bottom-2 right-2 bg-white/95 backdrop-blur-sm rounded-md px-1.5 py-0.5 shadow-sm" data-id="element-33">
                      <span className="font-heading font-black text-medical-blue text-xs" data-id="element-34">
                        {bono.id}
                      </span>
                    </div>
                  </div>

                  {/* Content side */}
                  <div className="flex-1 p-3 md:p-5 flex flex-col justify-center" data-id="element-35">
                    <div className="flex justify-between items-start gap-2" data-id="element-36">
                      <div className="flex-1 min-w-0" data-id="element-37">
                        <span className="text-[10px] md:text-xs font-bold text-success-green uppercase tracking-wider mb-0.5 block" data-id="element-38">
                          Bono {bono.id.replace('B', '')} · GRATIS
                        </span>
                        <h3 className="font-heading font-bold text-gray-900 text-sm md:text-lg leading-tight mb-1" data-id="element-39">
                          {bono.title}
                        </h3>
                        <p className="text-xs md:text-sm text-gray-500 truncate" data-id="element-40">
                          {bono.short}
                        </p>
                      </div>
                      <motion.div animate={{
                    rotate: isExpanded ? 180 : 0
                  }} transition={{
                    duration: 0.3
                  }} className={`shrink-0 p-1.5 rounded-full ${isExpanded ? 'bg-accent-gold text-medical-blue' : 'bg-gray-100 text-gray-500'}`} data-id="element-41">
                        <ChevronDown size={14} data-id="element-42" />
                      </motion.div>
                    </div>

                    <AnimatePresence data-id="element-43">
                      {isExpanded && <motion.div initial={{
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={{
                    height: 0,
                    opacity: 0
                  }} transition={{
                    duration: 0.3,
                    ease: 'easeInOut'
                  }} className="overflow-hidden" data-id="element-44">
                          <div className="pt-3 mt-2 border-t border-gray-100" data-id="element-45">
                            <p className="text-xs md:text-sm text-gray-700" data-id="element-46">
                              {bono.desc}
                            </p>
                            <div className="flex items-center gap-1.5 mt-2 text-xs text-success-green font-bold" data-id="element-47">
                              <CheckCircle2 size={12} data-id="element-48" />
                              <span data-id="element-49">Incluido sin costo extra</span>
                            </div>
                          </div>
                        </motion.div>}
                    </AnimatePresence>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>

        {/* Value Banner */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="mt-10 bg-gradient-to-r from-accent-gold to-yellow-400 rounded-2xl p-6 text-center shadow-2xl" data-id="element-50">
          <p className="text-medical-blue text-sm font-bold uppercase tracking-widest mb-1" data-id="element-51">
            Valor Total
          </p>
          <div className="flex items-baseline justify-center gap-3 flex-wrap" data-id="element-52">
            <span className="line-through text-medical-blue/50 text-xl md:text-2xl font-bold" data-id="element-53">
              $84.000
            </span>
            <span className="text-medical-blue text-3xl md:text-5xl font-black" data-id="element-54">
              GRATIS
            </span>
          </div>
          <p className="text-medical-blue/70 text-xs md:text-sm font-medium mt-2" data-id="element-55">
            Los 6 bonos incluidos con cualquier oferta
          </p>
        </motion.div>
      </div>
    </section>;
}